const initialState = {
  isThrottled: false,
  retryAfter: 0,
  throttledPath: null
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_THROTTLED':
      return {
        ...state,
        isThrottled: true,
        retryAfter: action.retryAfter,
        throttledPath: action.path
      };
    case 'CLEAR_THROTTLED':
      return {
        ...state,
        isThrottled: false,
        retryAfter: 0,
        throttledPath: null
      };
    default:
      return state;
  }
};

export default appReducer;
